/**
 * TenantLogo — logo del tenant resuelto en el FRONT por id (lib/images.js),
 * misma filosofía que el avatar de agente: si el asset no existe, se cae a la
 * insignia con la inicial del tenant sin romper el layout. En tema oscuro se
 * pide la variante `-dark` y, si el tenant no la tiene, se reintenta la clara
 * antes de caer a la insignia. Usado en LeftRail (marca) y Login.
 */

import { useState, useEffect } from 'react'
import { tenantLogoOf } from '../lib/images.js'

export function TenantLogo({ tenant, theme, height = 26, className = '' }) {
  const wanted = tenantLogoOf(tenant, theme)
  const claro = tenantLogoOf(tenant, 'light')
  const [src, setSrc] = useState(wanted)
  useEffect(() => { setSrc(wanted) }, [wanted])

  // Sin tenant resuelto (login en modo real, pre-bootstrap): insignia neutra
  // de plataforma («P» de Pórtico). Con tenant sin logo: su inicial.
  const inicial = (tenant?.nombre ?? 'Pórtico').trim().charAt(0).toUpperCase() || 'P'

  if (!src) {
    return (
      <span
        className={`tenant-logo tenant-logo--fallback ${className}`.trim()}
        style={{ height, width: height, fontSize: height * 0.5 }}
        aria-hidden="true"
      >
        {inicial}
      </span>
    )
  }

  return (
    <img
      className={`tenant-logo ${className}`.trim()}
      style={{ height }}
      src={src}
      alt={tenant?.nombre ?? ''}
      decoding="async"
      onError={() => setSrc(s => (s !== claro ? claro : null))}
    />
  )
}
